export { HeroSwitcher } from './HeroSwitcher';
